import { LocalDate } from '../../../../utils/date/local-date'
import { TYPE_TACHE } from '../../mobile/utils/constantsSuiviTache'

export const FAMILLES = {
	DES: 'DES',
	RECOLTE: 'RECOLTE',
	SEMIS: 'SEMIS',
	IMPLANTATION: 'IMPLANTATION',
	AUTRES: 'AUTRES',
	PREP_PLANCHE: 'PREP_PLANCHE',
	SOINS_PROTECTION: 'SOINS_PROTECTION'
}

export const getDatasetColor = (type: string): { foreground: string, background: string } => {
	switch (type) {
		case FAMILLES.SOINS_PROTECTION:
			return { foreground: '#FFF', background: '#1A8FE3' }
		case FAMILLES.PREP_PLANCHE:
			return { foreground: '#000', background: '#87CBAC' }
		case FAMILLES.DES:
			return { foreground: '#FFF', background: '#044389' }
		case FAMILLES.AUTRES:
			return { foreground: '#FFF', background: '#C97B84' }
		case FAMILLES.RECOLTE:
			return { foreground: '#000', background: '#E6C229' }
		case FAMILLES.SEMIS:
			return { foreground: '#FFF', background: '#F17105' }
		case FAMILLES.IMPLANTATION:
			return { foreground: '#FFF', background: '#67597A' }
		default:
			return { foreground: '#FFF', background: '#000' }
	}
}

/**
 * Affichage de la priorité avec un surplus si la tâche est en retard
 * @param taskPriorite
 * @param initialDate
 * @param plannedDate
 */
export const showPrioriteWithRetard = (taskPriorite: number, initialDate: string, plannedDate: string): number => {
	const initPriorite = taskPriorite

	// Différentiel de semaines entre dateInitiale et date planifiée
	if (initialDate !== plannedDate) {
		const initialLocalDate = LocalDate.fromAPI(initialDate)
		const plannedLocalDate = LocalDate.fromAPI(plannedDate)
		const diffWeeks = plannedLocalDate._diff(initialLocalDate, 'week')

		if (diffWeeks > 0) {
			return Math.trunc(initPriorite + (diffWeeks * 2))
		}
	}

	return initPriorite
}

/**
 * Conditionne l'affichage des champs tâche propre à une récolte
 * @param typeTache
 */
export const showFieldsTacheRecolte = (typeTache: string): boolean =>
	typeTache === TYPE_TACHE.RECOLTE

/**
 * Conditionne l'affichage des champs tâche propre au tri
 * @param typeTache
 */
export const showFieldsTacheTri = (typeTache: string): boolean =>
	typeTache.endsWith(TYPE_TACHE.TRI)

/**
 * Conditionne l'affichage des champs tâche propre à une fertilisation
 * @param typeTache
 */
export const showFieldsTacheFertilisation = (typeTache: string): boolean =>
	typeTache.startsWith(TYPE_TACHE.FERTI)